import { render, staticRenderFns } from "./prodect_control.vue?vue&type=template&id=a947e216&"
import script from "./prodect_control.vue?vue&type=script&lang=js&"
export * from "./prodect_control.vue?vue&type=script&lang=js&"
import style0 from "./prodect_control.vue?vue&type=style&index=0&id=a947e216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports